import axios from 'axios'

const API_BASE =
  import.meta.env.VITE_API_BASE_URL ??
  (process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : '')

const apiClientPlatform = axios.create({
  baseURL: `${API_BASE}/api/v1`,
  //headers: { 'Content-Type': 'application/json' },
})

apiClientPlatform.interceptors.request.use((config) => {
  const raw = localStorage.getItem('platformUserInfo')
  if (raw) {
    const { token } = JSON.parse(raw)
    if (token) config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// === Response: 401 -> on appelle un handler (branché dans StoreProvider)
let onUnauthorized: (() => void) | null = null
export function registerUnauthorizedHandler(fn: () => void) {
  onUnauthorized = fn
}

apiClientPlatform.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && onUnauthorized) {
      onUnauthorized()
    }
    return Promise.reject(err)
  }
)

export default apiClientPlatform
